module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag3-agnostic.15417a15.gif";